export var CheckboxCssClass;
(function (CheckboxCssClass) {
    CheckboxCssClass["Base"] = "iress-checkbox";
    CheckboxCssClass["Checked"] = "iress-checkbox--checked";
    CheckboxCssClass["Indeterminate"] = "iress-checkbox--indeterminate";
    CheckboxCssClass["Label"] = "iress-checkbox__label";
    CheckboxCssClass["Input"] = "iress-checkbox__input";
    CheckboxCssClass["Focus"] = "iress-checkbox--focus";
    CheckboxCssClass["Hover"] = "iress-checkbox--hover";
    CheckboxCssClass["Mark"] = "iress-checkbox__mark";
    CheckboxCssClass["HiddenControl"] = "iress-checkbox--hidden-control";
    CheckboxCssClass["HiddenLabel"] = "iress-checkbox--hidden-label";
    CheckboxCssClass["Border"] = "iress-checkbox--border";
    CheckboxCssClass["LabelSpan"] = "iress-checkbox__label-span";
})(CheckboxCssClass || (CheckboxCssClass = {}));
//# sourceMappingURL=checkbox.types.js.map